import { createAction } from '@reduxjs/toolkit';

export const loadFeaturesAction = createAction('features/loadFeatures');
